export enum StEnum {
    Open = "Open",
    Selected = "Selected",
    Pending="Pending",
    Rejected="Rejected"
  }